import { render, staticRenderFns } from "./SettleBankReturnResumeTableTitleColumn.vue?vue&type=template&id=572eb24e"
import script from "./SettleBankReturnResumeTableTitleColumn.vue?vue&type=script&lang=ts"
export * from "./SettleBankReturnResumeTableTitleColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports